import { useRoutes } from "react-router-dom";
import './styles/global.css';

import routes from "./Router";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  const { ThemeRoutes } = routes;
  const routing = useRoutes(ThemeRoutes);


  return (
    <AuthProvider>
      <div className="dark">
        {routing}
      </div>
    </AuthProvider>
  );
};

export default App;